// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/table/calendar/Calendar";
import { updateView } from "actions/table";
import { updateRangeAndFetch } from "actions/events/thunks";
import { DEFAULT_COLOR, DEFAULT_LIGHT_COLOR } from "utils/colors";

export const format = (isLight, byId, event) => {
  const { presetId, start, end } = event;
  const preset = byId[presetId];

  const color = isLight ? DEFAULT_LIGHT_COLOR : preset.color || DEFAULT_COLOR;

  return {
    ...event,
    preset: { color },
    start: new Date(start),
    end: new Date(end),
  };
};

const mapStateToProps = ({
  events: { events },
  presets: { byId, isLight },
  ux: { isSmall, language },
  table: { focus, updatedFromPicker, view },
}) => {
  return {
    events: events.map(format.bind(null, isLight, byId)),
    focus: new Date(focus),
    isSmall,
    language,
    updatedFromPicker,
    view,
  };
};

const mapDispatchToProps = {
  updateRangeAndFetch,
  updateView,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
